<template>
    <div class="app-body-container" style="padding-bottom: 30px">

        <!--工作概况-->
        <el-row class="mg-t-10">
            <el-col :span="24">
                <el-card shadow="hover" class="mycard-a">
                    <div class="mycard-title">
                        今日工作概况（单位：次）
                    </div>
                    <div class="job-info">
                        <div class="ji-item">
                            <div class="ji-item-inner">
                                <div class="ji-num">{{today_work.auditOrderNumber|formatNumber}}</div>
                                <div class="ji-name">审核订单</div>
                            </div>
                        </div>
                        <div class="ji-item">
                            <div class="ji-item-inner">
                                <div class="ji-num">{{today_work.printOrderNumber|formatNumber}}</div>
                                <div class="ji-name">打印订单</div>
                            </div>
                        </div>
                        <!--<div class="ji-item">-->
                            <!--<div class="ji-item-inner">-->
                                <!--<div class="ji-num">{{today_work.auditReturnNumber|formatNumber}}</div>-->
                                <!--<div class="ji-name">审核退货单</div>-->
                            <!--</div>-->
                        <!--</div>-->
                        <!--<div class="ji-item">-->
                            <!--<div class="ji-item-inner">-->
                                <!--<div class="ji-num">{{today_work.printLogisticsNumber|formatNumber}}</div>-->
                                <!--<div class="ji-name">打印物流单</div>-->
                            <!--</div>-->
                        <!--</div>-->
                        <div class="ji-item">
                            <div class="ji-item-inner">
                                <div class="ji-num">{{today_work.mergeOrderNumber|formatNumber}}</div>
                                <div class="ji-name">合并订单</div>
                            </div>
                        </div>
                        <div class="ji-item">
                            <div class="ji-item-inner">
                                <div class="ji-num">{{today_order.orderNumber|formatNumber}}</div>
                                <div class="ji-name">异常订单</div>
                            </div>
                        </div>
                    </div>
                    <!--<div class="job-info2">-->
                        <!--<div class="ji2-item">-->
                            <!--<div class="ji2-name">异常订单</div>-->
                            <!--<div class="ji2-num">{{today_order.orderNumber|formatNumber}}</div>-->
                        <!--</div>-->
                        <!--<div class="ji2-item">-->
                            <!--<div class="ji2-name">异常退货单</div>-->
                            <!--<div class="ji2-num">{{today_order.returnNumber|formatNumber}}</div>-->
                        <!--</div>-->
                    <!--</div>-->
                </el-card>
            </el-col>
        </el-row>

        <!--异常列表-->
        <el-row class="mg-t-10">
            <el-col :span="24">
                <el-card shadow="hover" class="mycard-a">
                    <div class="mycard-title">
                        异常列表
                    </div>
                    <!--选项卡-->
                    <el-tabs type="card" value="handle_no" class="mytabs" @tab-click="handleTabChange">
                        <el-tab-pane name="handle_no">
                            <span slot="label">
                                <el-badge :hidden="no_handle_num==0" :value="no_handle_num" class="mytabs-tab-badge">待处理</el-badge>
                            </span>
                        </el-tab-pane>
                        <el-tab-pane name="handle_yes">
                            <span slot="label">
                                <el-badge :value="0" class="mytabs-tab-badge" hidden>已处理</el-badge>
                            </span>
                        </el-tab-pane>
                    </el-tabs>
                    <!--表格-->
                    <el-table ref="r_mainTable" :data="main$data" v-loading="main$loading" @selection-change="handleSelectionChange" size="medium">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column prop="tag" label="" width="70">
                            <template slot-scope="scope">
                                <el-tag size="mini" class="err-table-tag">{{ scope.row.dataSourceStr }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="orderNumber" label="单号" width="160" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="createTime" label="时间" width="160" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="typeStr" label="类型" width="90" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="customerName" label="客户" width="200" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="reason" label="异常原因" show-overflow-tooltip align="center" header-align="center"> </el-table-column>
                        <el-table-column label="操作" width="180" align="center" header-align="center">
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.status==0"  type="text" class="mylinkbtn" @click="table_view(scope.row,scope.row.reason)">审核</el-button>
                                <el-button v-if="scope.row.status==1" type="text" class="mylinkbtn" @click="table_view(scope.row,scope.row.reason)">查看</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!--分页等-->
                    <div class="err-tb-pg-bar" style="margin: 14px">
                        <!--<el-checkbox label="全选" name="type" @change="selectAll"></el-checkbox>-->
                        <!--<el-button class="mylinkbtns" @click="table_audit_select">审核</el-button>-->
                        <!--<el-button class="mylinkbtns" @click="table_cancel_select">取消</el-button>-->
                        <!--<el-button class="mylinkbtns" @click="table_del_select">删除</el-button>-->
                        <!--<el-button class="mylinkbtns" @click="table_print_select">打印</el-button>-->
                        <el-pagination style="float: right;margin-bottom: 14px"
                                       background
                                       layout="total, sizes, prev, pager, next"
                                       :page-size="main$page_size"
                                       :current-page="main$curr_page"
                                       :total="main$total"
                                        @current-change="handlePageChange"></el-pagination>
                    </div>
                </el-card>
            </el-col>
        </el-row>

        <!--订单详情-->
        <el-dialog title="订单详情" :visible.sync="orderDetails" width="80%" class="mydialog mydialog_add_order_group" :append-to-body="true" top="5vh">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px">
            <el-row>
              <el-col :lg="24"><el-form-item label="异常原因"><span>{{ruleForm.orderDetails.reason}}</span></el-form-item></el-col>
              <el-col :lg="8"><el-form-item label="订单号"><span>{{ruleForm.orderDetails.deal_no}}</span></el-form-item></el-col>
              <el-col :lg="8"><el-form-item label="下单时间"><span>{{parseFloat(ruleForm.orderDetails.dd1) | formatConversion(1)}}</span></el-form-item></el-col>
              <el-col :lg="8">
                <el-form-item label="订单来源">
                  <div v-if="ruleForm.orderDetails.origin_id==3"><span style="color: #E6A23C">【代】</span>{{ruleForm.orderDetails.creator}}</div>
                  <div v-if="ruleForm.orderDetails.origin_id==2"><span style="color: #409EFF">【业】</span>{{ruleForm.orderDetails.salesman_name}}</div>
                  <div v-if="ruleForm.orderDetails.origin_id==1"><span style="color: #67C23A">【店】</span>{{ruleForm.orderDetails.ship_name}}</div>
                </el-form-item>
              </el-col>
              <el-col :lg="8">
                <el-form-item label="客户信息">
                  <span>{{ruleForm.orderDetails.buyer_name}} {{ruleForm.orderDetails.ship_name}} {{ruleForm.orderDetails.ship_mob}}</span>
                </el-form-item>
              </el-col>
              <el-col :lg="8"><el-form-item label="收货地址 "><span>{{ruleForm.orderDetails.ship_addrs}}</span></el-form-item></el-col>
            </el-row>
            <el-table
              ref="multipleTable"
              :data="tableDataList"
              tooltip-effect="dark"
              style="width: 100%;margin-top: 10px"
              border
              :summary-method="getSummaries"
              show-summary
              :height="clientHeight"
              size="small">
              <el-table-column show-overflow-tooltip align="center" header-align="center" :prop="item.key" :label="item.name" v-for="(item,i) in listDetails" :key="i"></el-table-column>
            </el-table>
            <el-row style="margin-top: 10px">
              <!--<el-col :lg="24"><el-form-item label="合计金额"><span>{{ruleForm.orderDetails.final_fee_str}}</span></el-form-item></el-col>-->
              <el-col :lg="24"><el-form-item label="订单备注"><span>{{ruleForm.orderDetails.remark_s}}</span></el-form-item></el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button v-if="status==0" type="primary" @click="table_audit(1)">审核</el-button>
            <el-button type="info" @click="table_see(1)">查看</el-button>
            <el-button @click="orderDetails=false">取消</el-button>
          </div>
        </el-dialog>
         <!--退货单详情-->
        <el-dialog title="退货单详情" :visible.sync="orderDetailss" width="80%" class="mydialog mydialog_add_order_group" :append-to-body="true" top="5vh">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px">
            <el-row>
              <el-col :lg="8"><el-form-item label="退单号"><p>{{ruleForm.orderDetailss.order_no}}</p></el-form-item></el-col>
              <el-col :lg="8"><el-form-item label="退货时间"><p>{{parseFloat(ruleForm.orderDetailss.dd1) | formatConversion(1)}}</p></el-form-item></el-col>
              <el-col :lg="8">
                <el-form-item label="客户信息">
                  <p>{{ruleForm.orderDetailss.buyer_name}} {{ruleForm.orderDetailss.ship_name}} {{ruleForm.orderDetailss.ship_mob}}</p>
                </el-form-item>
              </el-col>
              <el-col :lg="8">
                <el-form-item label="订单来源">
                  <p v-if="ruleForm.orderDetailss.origin_id==3"><span style="color: #E6A23C">【代】</span>{{ruleForm.orderDetailss.creator}}</p>
                  <p v-if="ruleForm.orderDetailss.origin_id==2"><span style="color: #409EFF">【业】</span>{{ruleForm.orderDetailss.salesman_name}}</p>
                  <p v-if="ruleForm.orderDetailss.origin_id==1"><span style="color: #67C23A">【店】</span>{{ruleForm.orderDetailss.ship_name}}</p>
                </el-form-item>
              </el-col>
              <el-col :lg="8"><el-form-item label="状态"><p>{{ruleForm.orderDetailss.states_desc}}</p></el-form-item></el-col>
              <el-col :lg="8"><el-form-item label="备注"><p>{{ruleForm.orderDetailss.s1}}</p></el-form-item></el-col>
            </el-row>
            <el-table
              ref="multipleTable"
              :data="tableDataLists"
              tooltip-effect="dark"
              style="width: 100%;margin-top: 10px"
              border
              :height="clientHeight"
              size="small">
              <el-table-column show-overflow-tooltip align="center" header-align="center" :prop="item.key" :label="item.name" v-for="(item,i) in listDetailss" :key="i"></el-table-column>
            </el-table>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="table_audit(2)">审核</el-button>
            <el-button type="info" @click="table_see(2)">查看</el-button>
            <el-button @click="orderDetailss=false">取消</el-button>
          </div>
        </el-dialog>

    </div>
</template>

<script>
export default {
    data: function () {
        return {
            orderDetails:false, //订单详情弹框
            orderDetailss:false, //退货单详情弹框
            // 工作概况
            today_work: {},
            today_order: {},
            // 异常列表
            main$query_status: 0,
            main$page_size: 20,
            main$curr_page: 1,
            main$loading: false,
            main$total: 0,
            main$data: [],
            main$selection: [],
            // 异常订单统计
            no_handle_num: 0,
            id:'',
            status:'',

            ruleForm: {
              orderDetails:{}, //订单详情
              orderDetailss:{}, //退货单单详情
            },
            tableDataList: [], //数据列表
            tableDataLists: [], //数据列表
            listDetails:[
              {name:'货号', key:"gcode"},
              {name:'商品名称', key:"goods_name"},
              {name:'规格', key:"spec_name"},
              {name:'单位', key:"unit_name"},
              {name:'条码', key:"barcode"},
              {name:'数量', key:"amount"},
              {name:'单价', key:"price"},
              {name:'小计', key:"total_fee"},
              {name:'备注', key:"remark"},
            ],
            listDetailss:[
              {name:'货号', key:"gcode"},
              {name:'商品名称', key:"goods_name"},
              {name:'规格', key:"spec_name"},
              {name:'单位', key:"unit_name"},
              {name:'条码', key:"barcode"},
              {name:'数量', key:"amount"},
              {name:'单价', key:"price"},
              {name:'小计', key:"final_fee"},
              {name:'退货入库方式', key:"ret_storage_cn"},
              {name:'退货原因', key:"reason"},
            ],
            clientHeight:'', //屏幕自适应高度
        }
    },
    methods: {
        //合计
        getSummaries(param){
          const { columns, data } = param;
          const sums = ['合计','','','','',0,'',0];
          for(let i of data){
            sums[5]+=parseInt(i.amount);
            sums[7]+=parseInt(i.total_fee);
          }
          return sums;
        },
        fetchData: function () {
            let self = this;

            self.main$loading = true

            // 表格数据
            self.xFetch.post(self.xApi('/robot/order/error/getErrorOrderList'), {
                page: self.main$curr_page,
                rows: self.main$page_size,
                status: self.main$query_status,
            },{xPostType:'form'}).then(function (res) {
                self.main$loading = false

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    self.main$total = 0;
                    self.main$data = [];
                }
                else {
                    self.main$total = res.data.total;
                    self.main$data = res.data.rows;
                }
            });

            // 统计待处理的异常订单
            self.xFetch.post(self.xApi('/robot/order/error/countSuspendingErrorOrder'), {}).then(function (res) {
                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    return
                }
                self.no_handle_num = res.data.data;
            });
        },
        handlePageChange: function (val) {
            this.main$curr_page = val;
            this.fetchData();
        },
        handleTabChange: function (tab, e) {
            if (tab.name == 'handle_no') this.main$query_status = 0;
            else this.main$query_status = 1;

            this.main$curr_page = 1;
            this.fetchData();
        },
        handleSelectionChange: function (val) {
            this.main$selection = val
        },
        selectAll:function(bol){
            let self = this
            self.main$data.forEach(function(row){
                self.$refs.r_mainTable.toggleRowSelection(row,bol);
            })
        },
        table_audit: function (row) {
          let self=this;
          let user = localStorage.getItem('sysale-robot$user');
          user = JSON.parse(user);
          if(row==1){
            self.xFetch.post(self.xApi('/robot/order/error/audit'), {id:self.id},{xPostType:'form'}).then(function (res) {
//            console.log(res)
              if(res.data.code == '00'){
                self.xEui.msg_success('审核成功');
                self.orderDetails=false;
                self.id='';
                self.fetchData();
              }else {
                self.xEui.msg_error('审核失败');
              }
            });
          }else if(row==2){
            let seq_id=[];
            let price=[];
            for(let i of self.tableDataLists){
              seq_id.push(i.seq_id);
              price.push(i.price);
            }
            let obj={
              order_id:parseFloat(self.ruleForm.orderDetailss.order_id), //退货单id
              order_no:self.ruleForm.orderDetailss.order_no, //
            };
            self.xFetch.post(self.xApi('/xx_admin/rbt.AutoDeal/auditRetdeal?sessionid='+user.data.sessionid), obj).then(function (res) {
//            console.log(res)
              if(res.data.ret_status='ok'){
                self.xEui.msg_success(res.data.rpc_msg);
                self.fetchData();
              }else {
                self.xEui.msg_error(res.data.rpc_msg);
              }
            });
          }
        },
        table_view: function (row,reason) {
          let self=this;
          self.id=row.id;
          self.status=row.status;
          let user = localStorage.getItem('sysale-robot$user');
          user = JSON.parse(user);
          if(row.type==1){
            self.xFetch.post(self.xApi('/xx_admin/deal.DhDealMgr/getDealInfo?sessionid='+user.data.sessionid), {deal_id:parseFloat(row.relatedId)}).then(function (res) {
//            console.log(res)
              if(res.data.ret_status='ok'){
                self.ruleForm.orderDetails=res.data;
                self.ruleForm.orderDetails.reason=reason;
              }
            });
            self.xFetch.post(self.xApi('/xx_admin/deal.DhDealMgr/getDealGoods?sessionid='+user.data.sessionid), {deal_id:parseFloat(row.relatedId)}).then(function (res) {
//            console.log(res)
              if(res.data.ret_status='ok'){
                for(let i of res.data.goods_list){
                  i.price=self.numMulti(i.price,0.01);
                  i.total_fee=self.numMulti(i.total_fee,0.01);
                }
                self.tableDataList=res.data.goods_list;
              }
            });
            self.orderDetails=true;
          }else if(row.type==2){
            self.xFetch.post(self.xApi('/xx_admin/deal.RetorderMgr/getRetorderInfo?sessionid='+user.data.sessionid), {order_id:parseFloat(row.relatedId)}).then(function (res) {
//            console.log(res)
              if(res.data.ret_status='ok'){
                self.ruleForm.orderDetailss=res.data;
                self.tableDataLists=res.data.items;
              }
            });
            self.orderDetailss=true;
          }
        },
        table_see: function (row) {
          let self=this;
          if(row==1){
            window.open('//corp.hixiaoxiao.com/xxadmin/index.html#/fullordersee/'+self.ruleForm.orderDetails.deal_id)
          }else if(row==2){
            window.open('//corp.hixiaoxiao.com/xxadmin/index.html#/returnordersee/'+self.ruleForm.orderDetailss.order_id)
          }
        },
        //乘法运算 避免数据相乘小数点后产生多位数和计算精度损失
        numMulti(num1, num2) {
          let baseNum = 0;
          try {
            baseNum += num1.toString().split(".")[1].length;
          } catch (e) {
          }
          try {
            baseNum += num2.toString().split(".")[1].length;
          } catch (e) {
          }
          return Number(num1.toString().replace(".", "")) * Number(num2.toString().replace(".", "")) / Math.pow(10, baseNum);
        },
        table_cancel: function (id) {
            // ×
            this.xEui.msg_success('取消订单')
        },
        table_audit_select: function () {
            // ×
            console.log(this.main$selection)
            this.xEui.msg_success('审核')
        },
        table_cancel_select: function () {
            // ×
            console.log(this.main$selection)
            this.xEui.msg_success('取消')
        },
        table_del_select: function () {
            // ×
            console.log(this.main$selection)
            this.xEui.msg_success('删除')
        },
        table_print_select: function () {
            // ×
            console.log(this.main$selection)
            this.xEui.msg_success('打印')
        },
    },
    created: function () {
        let self = this
        self.clientHeight=document.documentElement.clientHeight-550; //屏幕高度
        // 工作概况
        self.xFetch.post(self.xApi('/robot/order/error/getTodayOrder'), {}).then(function (res) {
            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                return
            }
            self.today_work = res.data.data.work
            self.today_order = res.data.data.order
        });

        // 表格数据
        self.fetchData();
    },
    filters: {
      formatConversion(date,n) {
        date = new Date(date);
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        let minute = date.getMinutes();
        minute = minute < 10 ? ('0' + minute) : minute;
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s;
        if(n==1){
          return y + '-' + m + '-' + d+' '+h+':'+minute+':'+s;
        }else {
          return y + '-' + m + '-' + d
        }
      },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .mycard-title{ color: #333 }
    /*job info*/
    .job-info { margin: 0px 40px;padding: 25px 0 30px 0}
    .job-info:after{ display: table;content: '';clear: both; }
    .job-info .ji-item{ width: 25%;float: left;text-align: center}
    .job-info .ji-item-inner{ display: inline-block;text-align: center }
    .job-info .ji-name{ font-size: 13px;color: #303133;margin-top: 2px;font-weight: 600 }
    .job-info .ji-num{ font-size: 28px;color: #409EFF; }
    .job-info2 { margin: 0px 40px;padding-top: 20px;}
    .job-info2:after{ display: table;content: '';clear: both; }
    .job-info2 .ji2-item{ width: 50%;float: left;position: relative;height: 46px;line-height: 46px;text-align: center }
    .job-info2 .ji2-item:first-child:after{
      display: table;
        content: '';
        position: absolute;
          height: 100%;
        top: 0px;
        right: 0px;
        border-right: 2px solid #EAEAEA;
    }
    .job-info2 .ji2-name{display: inline-block; font-size: 13px; color: #303133;vertical-align: top;margin-right: 50px;;font-weight: 600 }
    .job-info2 .ji2-num{ display: inline-block; font-size: 28px;color: #E55447;vertical-align: top }
    /*表格和分页*/
    .err-table-tag{ width: 50px;text-align: center;background: #7eaff9;color: #fff }
    .err-tb-pg-bar .mylinkbtn{ margin-left: 40px }
    .err-tb-pg-bar .mylinkbtns{ margin-left: 20px }

    /*mydialog_add_order_group*/
    .mydialog_add_order_group{ }
    .mydialog_add_order_group .dg-input{ width: 220px }
    .mydialog_add_order_group .dg-desc{ font-size: 13px;color: #909399; }
</style>
<style>
    /*mydialog_add_order_group*/
    .mydialog_add_order_group .el-dialog__body{ padding: 20px;padding-bottom: 0 }
    .mydialog_add_order_group .el-form-item{ margin-bottom: 0px }
</style>



// WEBPACK FOOTER //
// src/views/order/error.vue